import AbstractClaimGroupChildPage from '@rd-web-markets/shared/dist/pages/abstract/AbstractClaimGroupChildPage';
import CompanyReportPreview from '@rd-web-markets/shared/dist/reportPreview/CompanyReportPreview';
import ReportPreviewControls from '@rd-web-markets/shared/dist/reportPreview/ReportPreviewControls';
import projectRndReportService from '@rd-web-markets/shared/dist/services/claim_project_reports/project_rnd_report.service';
import claimProjectReportService from '@rd-web-markets/shared/dist/services/project_report/claim_project_report.service';
import { Loader } from '@rd-web-markets/shared/dist/util/Loader';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import EditProjectReportSliceModal from '../reportPreview/EditProjectReportSliceModal';
const isPdfGenerationPending = project => {
  let isPendingPdfGeneration = project.change_sets?.some(changeSet => {
    return changeSet.reportSnapshots?.some(snapshot => {
      const pdf_generation_status = snapshot.rnd_report.pdf_generation_status;
      const isPendingPdfGeneration = ['pending', 'not_started'].includes(pdf_generation_status);
      return isPendingPdfGeneration;
    });
  });
  return isPendingPdfGeneration;
};
const ProjectRndReportsPage = AbstractClaimGroupChildPage({
  highlightedMenuItem: 'technical_narratives',
  ClaimGroupChildPage: function (_ref) {
    let {
      accountType,
      handleToaster,
      claimGroup,
      setClaimGroup,
      resetClaimGroup,
      t,
      pageIsLoading,
      setPageIsLoading: setLoading
    } = _ref;
    const {
      project_id: projectId
    } = useParams();
    const [isUnderReview, setIsUnderReview] = useState(false);
    const [shouldShowComments, setShouldShowComments] = useState(true);
    const [aReportGenerationIsPending, setAReportGenerationIsPending] = useState(false);
    const [project, setProject, fetchAndSetProject] = claimProjectReportService.useGet(claimGroup.id, projectId, setLoading, useCallback(project => setAReportGenerationIsPending(isPdfGenerationPending(project)), []), useMemo(() => ({
      include_rnd_reports: true
    }), []));
    const previewProjectRndReportFinalVersion = projectRndReportService.usePreviewProjectRndReportFinalVersion({
      projectId,
      setLoading
    });
    const previewProjectRndReportHighlightsVersion = projectRndReportService.usePreviewProjectRndReportHighlightsVersion({
      projectId,
      setLoading,
      shouldShowComments: shouldShowComments && isUnderReview
    });
    const generateProjectRndReport = projectRndReportService.useCreate({
      projectId,
      setLoading
    });
    const deleteProjectRndREport = projectRndReportService.useDelete({
      projectId,
      setLoading
    });
    const [pollIntervalId, setPollIntervalId] = useState(null);
    const generateReport = async report_type => {
      setAReportGenerationIsPending(true);
      await generateProjectRndReport({
        report_type,
        show_comments: shouldShowComments && isUnderReview
      });
    };
    useEffect(() => {
      if (project?.active_change_set) {
        setIsUnderReview(true);
      }
    }, [project]);
    useEffect(() => {
      if (aReportGenerationIsPending && !pollIntervalId) {
        const intervalId = window.setInterval(() => {
          fetchAndSetProject();
        }, 2000);
        setPollIntervalId(intervalId);
      } else if (!aReportGenerationIsPending && pollIntervalId) {
        // clear if any interval previously started
        window.clearInterval(pollIntervalId);
        setPollIntervalId(null);
        handleToaster('Report PDF generation finished.');
      }
    }, [aReportGenerationIsPending, fetchAndSetProject, handleToaster, pollIntervalId]);
    if (!project) {
      return /*#__PURE__*/React.createElement(Loader, null);
    }
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ReportPreviewControls, {
      isGenerateButtonDisabled: aReportGenerationIsPending,
      aReportGenerationIsPending: aReportGenerationIsPending,
      generateReport: generateReport,
      isUnderReview: isUnderReview,
      claimGroupRndReportTemplate: null,
      accountType: accountType,
      reportType: null,
      shouldShowComments: shouldShowComments,
      setShouldShowComments: setShouldShowComments,
      nonRndReportSnapshots: project.non_rnd_reports_snapshots,
      getRndReportDownloadLink: rndReport => `/api/claim_project_reports/${projectId}/project_rnd_reports/${rndReport.id}`,
      deleteRndReport: rndReport => deleteProjectRndREport(rndReport.id)
    }), /*#__PURE__*/React.createElement(Row, {
      className: "text-center mt-5 justify-content-md-center"
    }, /*#__PURE__*/React.createElement(Col, {
      md: "auto"
    }, /*#__PURE__*/React.createElement(Card, {
      className: "border-0 ms-auto me-auto"
    }, /*#__PURE__*/React.createElement(Card.Header, {
      className: "border-0 bg-secondary bg-gradient"
    }, /*#__PURE__*/React.createElement("h4", {
      className: "text-center text-secondary"
    }, "Preview")), /*#__PURE__*/React.createElement(Card.Body, null, /*#__PURE__*/React.createElement(CompanyReportPreview, {
      changeSetContainingObject: project,
      reportTemplateId: null,
      claimId: null,
      changeClaimId: null,
      claimGroup: claimGroup,
      shouldShowComments: isUnderReview && shouldShowComments,
      previewRndReportFinalVersion: previewProjectRndReportFinalVersion,
      previewRndReportHighlightsVersion: previewProjectRndReportHighlightsVersion,
      EditProjectReportSliceModal: EditProjectReportSliceModal
    }))))));
  }
});
export default ProjectRndReportsPage;